// Garde-fou : redemander le PIN avant une action qui engage quelqu'un.
// Usage : if (!(await requirePin('Signaler une erreur'))) return;
// La fenêtre de saisie est rendue par <PinGuardModal /> dans App.jsx.
let _resolver = null;
let _lastOk = 0;
const GRACE_MS = 2 * 60 * 1000; // PIN validé il y a < 2 min : pas redemandé (enchaînement d'actions)

export function requirePin(label) {
  if (Date.now() - _lastOk < GRACE_MS) return Promise.resolve(true);
  return new Promise((resolve) => {
    _resolver = resolve;
    try { window.dispatchEvent(new CustomEvent('elixir:pin-request', { detail: { label } })); }
    catch { resolve(true); }
  });
}

export async function verifyPinRemote(pin) {
  const res = await fetch('/.netlify/functions/auth', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
    body: JSON.stringify({ action: 'verifyPin', params: { pin } }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) return { ok: false, error: json.error || 'HTTP ' + res.status };
  return json.result || { ok: false, error: json.error || 'Erreur' };
}

export function _settlePin(ok) {
  if (ok) _lastOk = Date.now();
  const r = _resolver; _resolver = null;
  if (r) r(!!ok);
}
